import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Inject
} from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { UserService } from 'src/shared/services/user/user.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DocumentRequestService } from 'src/app/v2-node-api/services/document-request.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UploadDocumentsService } from '../../+my-libraries/+sites/document-library/shared/services/upload-documents.service';
import { NodesService } from '../../+my-libraries/+sites/document-library/shared/services/nodes.service';

@Component({
  selector: 'upload-documents',
  templateUrl: './upload-documents.component.html',
  styleUrls: ['./upload-documents.component.scss']
})
export class UploadDocumentsComponent implements OnInit {
  public numberOfDocuments = 0;
  dynamicForm: FormGroup;
  public documents: any[] = [];
  public loadingPage: boolean;
  public seeAsSenderValidating: boolean;
  public requestInvalidated: boolean;
  public invalidReasonContent: string;

  @ViewChild('UploadFileInput', { static: false }) uploadFileInput: ElementRef;
  @ViewChild('formFileUpload', { static: false }) formFileUpload: ElementRef;
  fileUploadForm: FormGroup;
  fileInputLabel: string;

  constructor(
    private formBuilder: FormBuilder,
    public userService: UserService,
    private uploadDocuments: UploadDocumentsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<UploadDocumentsComponent>,
    protected documentRequestService: DocumentRequestService,
    private nodeService: NodesService,
    private snackBar: MatSnackBar
  ) {
  }

  ngOnInit(): void {
    this.invalidReasonContent = '';

    this.seeAsSenderValidating = this.data.seeAsSenderValidating;

    this.dynamicForm = this.formBuilder.group({
      numberOfDocuments: ['', Validators.required],
      documents: new FormArray([])
    });

    this.numberOfDocuments = this.data.request.documents.length;

    if (this.t.length < this.numberOfDocuments) {
      for (let i = this.t.length; i < this.numberOfDocuments; i++) {
        this.t.push(
          this.formBuilder.group({
            name: ['', Validators.required],
            done: [false],
            title: [this.data.request.documents[i].title],
            id: [this.data.request.documents[i]._id],
            data: [this.data.request.documents[i].data],
            nodeId: [''],
            loading: [false]
          })
        );
      }
    } else {
      for (let i = this.t.length; i >= this.numberOfDocuments; i--) {
        this.t.removeAt(i);
      }
    }
  }

  get f() {
    return this.dynamicForm.controls;
  }

  get t() {
    return this.f.documents as FormArray;
  }

  onFileSelect(event, index) {
   if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.t.controls[index].value.loading = true;

      this.t.controls[index].value.name = file.name;

      if (this.userService.actualRoleSite.isConsumer) {
      } else {
        this.uploadDocuments
          .uploadSingleFile(file, this.data.request.container.id, '')
          .then(res => {
            if (res) {
              this.t.controls[index].value.done = true;

              this.data.request.documents[index].status = 'waiting';

              this.documentRequestService
                .uploadFile(
                  this.data.request._id,
                  this.data.request.documents[index]._id,
                  {
                    data: res.body.entry,
                    status:"waiting"
                  }
                )
                .subscribe(res => {
                });
              this.t.controls[index].value.loading = true;
              this.t.controls[index].value.loading = false;

              this.t.controls[index].value.nodeId = res.body.entry.id;
            }
          })
          .catch(err => {
            let message = 'An error has occured';
            this.formFileUpload.nativeElement.reset();

            if (err.status === 403) {
              message = 'Permission error';
            }

            this.snackBar.open(message, null, {
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: ['danger-msg'],
              duration: 2000,
            });
          })
          .finally(() => {
            this.t.controls[index].value.loading = false;
          });
      }
    }

  }

  onFormSubmit() {
    if (!this.fileUploadForm.get('myfile').value) {
      alert('Please fill valid details!');
      return false;
    }

    const formData = new FormData();
    formData.append('formFile', this.fileUploadForm.get('myfile').value);
    formData.append('agentId', '007');
  }

  onSubmit() {
    this.documentRequestService.validateDocumentRequest(this.data.request._id).toPromise()
      .then(res => {
        this.data.request.status = 'waiting';
        this.dialogRef.close(true);
      })
      .catch((err) => {
        this.snackBar.open('An error has occured', null, {
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: ['danger-msg'],
          duration: 800,
        });
      });
  }


  clearFile(index) {
    var nodeId = '';
    const documentRequestId = this.data.request._id;
    const documentId = this.data.request.documents[index]._id;

    if (this.data.request.documents[index].data) {
      nodeId = this.data.request.documents[index].data.id;
    } else {

      nodeId = this.t.controls[index].value.nodeId;
    }


    this.nodeService.delete(nodeId).then((result) => {
      this.data.request.documents[index].status = 'pending';
      this.data.request.documents[index].data = null;
      this.data.request.documents[index].done = false;
      this.t.controls[index].value.done = false;
      this.t.controls[index].value.data = null;
      this.documentRequestService.clearFile(documentRequestId, documentId).subscribe(res => {
      });
    });
  }

  async onInvalidate() {
    this.requestInvalidated = true;
    const documentRequestId = this.data.request._id;

    await this.documentRequestService.invalidateDocumentRequest(documentRequestId, this.invalidReasonContent);
    this.dialogRef.close('invalidated');
  }

   onCloseRequest() {
    const documentRequestId = this.data.request._id;
    this.documentRequestService.closeDocumentRequest(documentRequestId).subscribe((res)=>{
      this.dialogRef.close('closed');
    });
  
  }
}
